import axios from 'axios'
import vue from '@/main'
import store from '@/store'

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.BASE_URL : '/',
  timeout: 10000
})

// request.interceptors.request.use((config) => {
//   config.headers.Authorization = user.state.token
//   return config
// })

request.interceptors.response.use(
  response => {
    if (!response.data) {
      return Promise.reject(response)
    }

    const { code, msg, error } = response.data

    if (code === 0) return response.data

    // eslint-disable-next-line
    // console.log('response.data.code is not 0', response.data, response.config.url)

    switch (code) {
      case 52:
        // 用户名或者密码错误，登陆页面已有提示
        break
      case 51: // 没有登陆/登陆超时
        // 公众号自动重新登陆，不弹框
        if (store.state.user.openid) {
          store.dispatch('user/clearToken').then(() => {
            window.location.reload()
          })
        } else {
          // 弹出对话框，跳转 login
          store.state.user.showReLoginDialog = true
        }
        break
      case 54:
        vue.$message({
          message: '没有权限',
          type: 'error'
        })
        break
      // 微信没有绑定
      case 56:
        window.location.replace('http://' + process.env.VUE_APP_HOST + '/wx/login?reset=true')
        break
      case 202:
        vue.$message({
          message: msg,
          type: 'error'
        })
        break
      default:
        vue.$message({
          message: error || msg,
          type: 'warning'
        })
    }
    return Promise.reject(response.data)
  },
  error => {
    return Promise.reject(error)
  }
)

// -------------------------- 数据 --------------------------
export function getKvList (className) {
  return request.get('/data/kvList?className=' + className)
}

export function getData (name) {
  return request.get('/data/getData?name=' + name)
}

export function positionsMayAuthorize (organType) {
  return request.get(`/data/positionsMayAuthorize?organType=${organType}`)
}

// ------------------------ 当前用户 --------——----------------
export function login (loginRequest) {
  return request.post('/anon/login', loginRequest)
}

export function logout () {
  return request.post('/user/logout')
}

export function myInfo () {
  return request.get('/user/myInfo')
}

export function myWorkScope () {
  return request.get('/user/myWorkScope')
}

// -------------------------- 用户 --------------------------
export function userListByOrgan (organType, organId) {
  return request.get(`/user/userListByOrgan?organType=${organType}&organId=${organId}`)
}

export function addUser (user) {
  return request.post('/user/addUser', user)
}

export function updateUser (user) {
  return request.post('/user/updateUser', user)
}

export function deleteUser (user) {
  return request.post('/user/deleteUser', user)
}

export function technicianList () {
  return request.get('/user/technicianList')
}

export function punchIn () {
  return request.post('/user/punchIn')
}

export function punchOut () {
  return request.post('/user/punchOut')
}

export function punchTimeList () {
  return request.get('/user/punchTimeList')
}

// 解除微信绑定
export function unbindOpenid (user) {
  return request.post('/user/unbindOpenid', user)
}

// -------------------------- 工单 --------------------------
export function addWork (work) {
  work.enterTime = work.enterTime.format('yyyy-MM-dd hh:mm:ss')
  work.estimateDeliveryTime = work.estimateDeliveryTime.format('yyyy-MM-dd hh:mm:ss')

  return request.post('/api/addWork', work)
}

// 途中增项
export function addParts2Work (work) {
  delete work.enterTime
  work.estimateDeliveryTime = work.estimateDeliveryTime.format('yyyy-MM-dd hh:mm:ss')
  return request.post('/api/addParts2Work', work)
}

export function updateWork (work) {
  work.enterTime = work.enterTime.format('yyyy-MM-dd hh:mm:ss')
  work.estimateDeliveryTime = work.estimateDeliveryTime.format('yyyy-MM-dd hh:mm:ss')

  return request.post('/api/updateWork', work)
}

export function deleteWork (id) {
  return request.post('/api/deleteWork', { id })
}

export function getKanbanWorks (queryType) {
  return request.get('/api/kanbanWorks?queryType=' + queryType)
}

export function getWorkDetail (workId) {
  return new Promise((resolve, reject) => {
    request.get('/api/workDetail?workId=' + workId).then(response => {
      const work = response.data
      work.enterTime = new Date(work.enterTime)
      work.estimateDeliveryTime = new Date(work.estimateDeliveryTime)
      resolve(work)
    }).catch(error => {
      reject(error)
    })
  })
}

export function dispatchWorkProcedures (workId) {
  return request.get('/api/dispatchWorkProcedures?workId=' + workId)
}

export function afterWorkProcedures (workId) {
  return request.get('/api/afterWorkProcedures?workId=' + workId)
}

export function confirmWork (dispatchList) {
  return request.post('/api/confirmWork', dispatchList)
}

export function pushWork (workId) {
  return request.post('/api/pushWork', {
    workId
  })
}

export function dispatchWork (dispatchList) {
  return request.post('/api/dispatchWork', dispatchList)
}

export function withdraw (workId) {
  return request.post('/api/withdraw', {
    workId
  })
}

export function rework (workId) {
  return request.post('/api/rework', {
    workId
  })
}

export function interruptWork (req) {
  return request.post('/api/interrupt', req)
}

export function qualityInspect (req) {
  return request.post('/api/qualityInspect', req)
}

export function startWork (workId) {
  return request.post('/api/startWork', {
    workId
  })
}

export function stopWork (workId) {
  return request.post('/api/stopWork', {
    workId
  })
}

export function endWork (workId) {
  return request.post('/api/endWork', {
    workId
  })
}

export function startWash (workId) {
  return request.post('/api/startWash', { workId })
}

export function endWash (workId) {
  return request.post('/api/endWash', {
    workId
  })
}

export function completeDelivery (workId) {
  return request.post('/api/completeDelivery', {
    workId
  })
}

export function completeSettlement (workId) {
  return request.post('/api/completeSettlement', {
    workId
  })
}
export function fallBack (workId, workStatus, reasonId, procedureId) { // 工单回退派工
  return request.post('/api/fallBack', {
    workId,
    workStatus,
    reasonId,
    procedureId
  })
}

// -------------------------- 工序 --------------------------
export function addProcedure (procedure) {
  return request.post('/api/addProcedure', procedure)
}

export function deleteProcedure (id) {
  return request.post('/api/deleteProcedure', { id })
}

export function updateProcedure (procedure) {
  return request.post('/api/updateProcedure', procedure)
}

export function getMiddleProcedures () {
  return request.get('/api/getMiddleProcedures')
}

export function updateMiddleProceduresSeq (procedureList) {
  return request.post('/api/updateMiddleProceduresSeq', procedureList)
}

// -------------------------- 工位 --------------------------
export function allStations () {
  return request.get('/api/allStations')
}

export function addStation (station) {
  return request.post('/api/addStation', station)
}

export function updateStation (station) {
  return request.post('/api/updateStation', station)
}

export function deleteStation (id) {
  return request.post('/api/deleteStation', { id })
}

// -------------------------- 工组 --------------------------
export function allTeams () {
  return request.get('/api/allTeams')
}

export function addTeam (team) {
  return request.post('/api/addTeam', team)
}

export function updateTeam (team) {
  return request.post('/api/updateTeam', team)
}

export function deleteTeam (id) {
  return request.post('/api/deleteTeam', { id })
}

export function teamsOfTechniciansByProcedure (procedureId) {
  return request.get('/api/teamsOfTechniciansByProcedure?procedureId=' + procedureId)
}

export function teamById (id) {
  return request.get('/api/teamById?id=' + id)
}

// -------------------------- 机构 --------------------------
export function allOrgans () {
  return request.get('/api/allOrgans')
}

export function allOrgansInLevels () {
  return request.get('/api/allOrgansInLevels')
}

export function addOrgan (organ) {
  return request.post('/api/addOrgan', organ)
}

export function updateOrgan (organ) {
  return request.post('/api/updateOrgan', organ)
}

export function deleteOrgan (organ) {
  return request.post('/api/deleteOrgan', organ)
}

// -------------------------- 品牌 --------------------------
export function allBrands () {
  return request.get('/api/allBrands')
}

export function addBrand (brand) {
  return request.post('/api/addBrand', brand)
}

export function updateBrand (brand) {
  return request.post('/api/updateBrand', brand)
}

export function deleteBrand (id) {
  return request.post('/api/deleteBrand', { id })
}

// -------------------------- 车系 --------------------------
export function allModels () {
  return request.get('/api/allModels')
}

export function firstModel (brandId) {
  return request.get('/api/firstModel?brandId=' + brandId)
}

export function addModel (model) {
  return request.post('/api/addModel', model)
}

export function updateModel (model) {
  return request.post('/api/updateModel', model)
}

export function deleteModel (id) {
  return request.post('/api/deleteModel', { id })
}

// -------------------------- 客户 --------------------------
export function allCustomers () {
  return new Promise((resolve, reject) => {
    request.get('/api/allCustomers').then(response => {
      for (const customer of response.data) {
        if (customer.birthday) {
          customer.birthday = new Date(customer.birthday)
        }
      }
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })

  // return request.get('/api/allCustomers')
}

export function customerByCarNo (carNo) {
  return request.get('/api/customerByCarNo?carNo=' + carNo)
}

export function customerByCellphone (cellphone) {
  return request.get('/api/customerByCellphone?cellphone=' + cellphone)
}

export function addCustomer (customer) {
  if (customer.birthday) {
    customer.birthday = customer.birthday.format('yyyy-MM-dd')
  }
  return request.post('/api/addCustomer', customer)
}

export function updateCustomer (customer) {
  if (customer.birthday) {
    customer.birthday = customer.birthday.format('yyyy-MM-dd')
  }
  return request.post('/api/updateCustomer', customer)
}

export function deleteCustomer (id) {
  return request.post('/api/deleteCustomer', { id })
}

// -------------------------- 施工项目 --------------------------
export function allParts () {
  return request.get('/api/allParts')
}

export function addParts (parts) {
  return request.post('/api/addParts', parts)
}

export function updateParts (parts) {
  return request.post('/api/updateParts', parts)
}

export function deleteParts (id) {
  return request.post('/api/deleteParts', { id })
}

// -------------------------- 施工项目系数 --------------------------
export function allPartsCoe () {
  return request.get('/api/allPartsCoe')
}

export function addPartsCoe (partsCoe) {
  return request.post('/api/addPartsCoe', partsCoe)
}

export function updatePartsCoe (partsCoe) {
  return request.post('/api/updatePartsCoe', partsCoe)
}

export function deletePartsCoe (id) {
  return request.post('/api/deletePartsCoe', { id })
}

// -------------------------- 页面访问权 --------------------------
export function pagePermissionTree () {
  return request.get('/api/pagePermissionTree')
}

export function updatePagePermissions (id, type, pagePermissions) {
  return request.post('/api/updatePagePermissions', {
    id,
    type,
    pagePermissions
  })
}

// -------------------------- 字典管理 --------------------------
export function allDictItems () {
  return request.get('/api/allDictItems')
}

export function saveOrUpdateDictItem ({ id, value, code, type }) {
  return request.post('/api/saveOrUpdateDictItem', {
    id,
    value,
    code,
    type
  })
}

export function deleteDictItem (id) {
  return request.post('/api/deleteDictItem', {
    id
  })
}

// -------------------------- 系统日志 --------------------------
export function latestLog (days) {
  return request.get('/api/latestLog?days=' + days)
}

// -------------------------- 历史工单 --------------------------
export function historyWorks (currentPage, pageSize, begTime, endTime, searchText) {
  let url = `/api/historyWorks?currentPage=${currentPage}&pageSize=${pageSize}`
  if (begTime) {
    url += '&begTime=' + begTime
  }
  if (endTime) {
    url += '&endTime=' + endTime
  }
  if (searchText) {
    url += '&searchText=' + searchText
  }
  return request.get(url)
}

export function historyKanbanWorks (currentPage, pageSize, begTime, endTime, searchText) {
  let url = `/api/historyKanbanWorks?currentPage=${currentPage}&pageSize=${pageSize}`
  if (begTime) {
    url += '&begTime=' + begTime
  }
  if (endTime) {
    url += '&endTime=' + endTime
  }
  if (searchText) {
    url += '&searchText=' + searchText
  }
  return request.get(url)
}

// -------------------------- 交车看板 --------------------------
export function deliveryPlan () {
  return request.get('/api/deliveryPlan')
}

// -------------------------- 工单操作记录 --------------------------
export function workOperaRecord (workId) {
  return request.get('/api/workOperaRecord?workId=' + workId)
}

// -------------------------- 技师负载计划 --------------------------
export function technicianWorkPlanList (date) {
  return request.get('/api/technicianWorkPlanList?date=' + date)
}

// -------------------------- 技师维修统计(预计) --------------------------
export function technicianWorkHours (begTime, endTime) {
  let url = '/api/technicianWorkHours?'
  if (begTime) {
    url += '&begTime=' + begTime
  }
  if (endTime) {
    url += '&endTime=' + endTime
  }
  return request.get(url)
}

// -------------------------- 重置自动派工 --------------------------
export function resetAutoDispatch () {
  return request.post('/api/resetAutoDispatch')
}

// -------------------------- 今日交车数量 --------------------------
export function todayDeliveryNum () {
  return request.get('/api/todayDeliveryNum')
}

// -------------------------- 计算派工计划时间 --------------------------
export function calWorkPlan (dispatchList) {
  return request.post('/api/calWorkPlan', dispatchList)
}

// -------------------------- 工单进度对比 --------------------------
export function workProgressList (date) {
  return request.get('/api/workProgressList?date=' + date)
}

// -------------------------- 微信接口 --------------------------
export function wxLogin (code) {
  return request.get('/wx/wxLogin?code=' + code)
}

export function wxMyInfo () {
  return request.get('/wx/myInfo')
}

export function bindOpenid (cellphone, openid) {
  return request.post('/wx/bindOpenid', {
    cellphone,
    openid
  })
}

// -------------------------- 微信端技师维修统计(预计) --------------------------
export function technicianWorkHoursByWeChat (tid, begTime, endTime) {
  let url = '/api/technicianWorkHoursByWeChat?'
  url += 'technicianId=' + tid
  if (begTime) {
    url += '&begTime=' + begTime
  }
  if (endTime) {
    url += '&endTime=' + endTime
  }

  return request.get(url)
}

// -------------------------- 微信端车辆进度查询 --------------------------
export function weChatProgressQuery (carNo) {
  return request.get('/api/weChatProgressQuery?carNo=' + carNo)
}

// -------------------------- 仓库 --------------------------
export function allWarehouses () {
  return request.get('/api/allWarehouses')
}

export function addWarehouse (warehouse) {
  return request.post('/api/addWarehouse', warehouse)
}

export function updateWarehouse (warehouse) {
  return request.post('/api/updateWarehouse', warehouse)
}

export function deleteWarehouse (id) {
  return request.post('/api/deleteWarehouse', { id })
}

// -------------------------- 库位 --------------------------
export function allWarehousePos () {
  return request.get('/api/allWarehousePos')
}

export function addWarehousePos (warehousePos) {
  return request.post('/api/addWarehousePos', warehousePos)
}

export function updateWarehousePos (warehousePos) {
  return request.post('/api/updateWarehousePos', warehousePos)
}

export function deleteWarehousePos (id) {
  return request.post('/api/deleteWarehousePos', { id })
}

// -------------------------- 商品 --------------------------
export function allGoods () {
  return request.get('/api/allGoods')
}

export function findGoods (goodsRequest) {
  return request.post('/api/findGoods', goodsRequest)
}

export function addGoods (goods) {
  return request.post('/api/addGoods', goods)
}

export function updateGoods (goods) {
  return request.post('/api/updateGoods', goods)
}

export function deleteGoods (id) {
  return request.post('/api/deleteGoods', { id })
}

// -------------------------- 入库 --------------------------
export function allInbounds () {
  return request.get('/api/allInbounds')
}

export function addInbound (inbound) {
  return request.post('/api/addInbound', inbound)
}

export function updateInbound (inbound) {
  return request.post('/api/updateInbound', inbound)
}

export function deleteInbound (id) {
  return request.post('/api/deleteInbound', { id })
}

export function deleteInboundGoods (goodsList) {
  return request.post('/api/deleteInboundGoods', goodsList)
}

// -------------------------- 出库 --------------------------
export function allOutbounds () {
  return request.get('/api/allOutbounds')
}

export function addOutbound (outbound) {
  return request.post('/api/addOutbound', outbound)
}

export function updateOutbound (outbound) {
  return request.post('/api/updateOutbound', outbound)
}

export function deleteOutbound (id) {
  return request.post('/api/deleteOutbound', { id })
}

// -------------------------- 内领 --------------------------
export function allNeilings () {
  return request.get('/api/allNeilings')
}

export function addNeiling (neiling) {
  return request.post('/api/addNeiling', neiling)
}

export function updateNeiling (neiling) {
  return request.post('/api/updateNeiling', neiling)
}

export function deleteNeiling (id) {
  return request.post('/api/deleteNeiling', { id })
}
